import { TextField, Typography, Button, Link } from '@mui/joy';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { signInUser, validateEmail } from '../controllers/auth';
import { setSnackbar } from '../controllers/snackController';
import Layout from '../Layout';
import { useSnackbarDispatch } from '../SnackbarDataStore/Context';
import { useDispatchContext, useStateContext } from '../Store/Context';
import VerifyOtp from './VerifyOtp';
import NavBar from './WebPageComponents/NavBar';

function SignIn() {

	const [email, setEmail] = useState("");
	const [disabled, setDisabled] = useState(false);

	const {otpSent, medium} = useStateContext();
	const dispatch = useDispatchContext();
	const snackDispatch = useSnackbarDispatch();

	async function handleSignIn () {
		setDisabled(true);
		if (email==="") {
			setSnackbar(snackDispatch, "Please enter email", 'error')
		} else if (!validateEmail(email)) {
			setSnackbar(snackDispatch, "Enter valid email", 'warning')
		} else {
			const signIn = await signInUser(email, dispatch);
			if (!signIn) {
				setSnackbar(snackDispatch, "User does not exist", 'error');
			}
		}
		setDisabled(false);
	}

	if (otpSent) {
		return(
			<VerifyOtp/>
		)
	}

	return (
		<>
			{medium==='web'&&<NavBar/>}
			<Layout>
				<div className='mb-4'>
					<Typography level='h4'>Login</Typography>
					<Typography variant='plain'>You will receive an OTP on your registered email.</Typography>
				</div>
				<div className='mb-4'>
					<div className='mb-2'>
						<TextField
							onChange={(e) => setEmail(e.target.value)}
							name="email"
							variant='soft'
							placeholder="google@rajnikant.world"
							label="Email"
							value={email}
						/>
					</div>
					<Button disabled={disabled} sx={{ mt: 1 /* margin top */ }} onClick={handleSignIn}>Send OTP</Button>
				</div>
				<div className='mb-4'>
					<Typography>Don't have an account, <Link component={RouterLink} to={"/signup"}>Create a new account</Link></Typography>
				</div>
			</Layout>
		</>
	)
}

export default SignIn;